import { analytics } from "MVVM/Analytics";
import {
  rememberSignup,
  SIGNUP_PLAN_EXPERIMENT,
} from "MVVM/State/signupPlanExperiment";

export const enrollSignupPlan = (userId: string, provider: string) => {
  const assignment = rememberSignup(userId, provider);
  analytics.identify(userId, { signup_plan_variant: assignment.variant });
  analytics.track("Signup Plans - Assigned", {
    experiment: SIGNUP_PLAN_EXPERIMENT,
    signup_plan_variant: assignment.variant,
    account_id: userId,
    signup_provider: provider,
    forced: assignment.forced,
  });
  return assignment;
};
